// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d855a71b","893":"10e62e29","976":"f00a95b9"}[chunkId] + ".chunk.js";
};